import { c as _c } from "react/compiler-runtime";
import { BottomSheetBody, BottomSheetHeader, BottomSheetHeaderTitle, Flex, FlexColumn, Item, ItemAvatar, ItemContent, ItemDescription, ItemTitle, NumberDisplay, Separator, TextBody, useToasts } from "@opensea/ui-kit";
import { useCallback } from "react";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { ActionTimeline } from "../../../components/ActionTimeline";
import { FlowActions, FlowState } from "../../../stores/flowStore";
import { TokenClaimToast } from "../../ToastHandler/TokenClaimToast/TokenClaimToast";
import { TokenClaimStatus } from "./components/TokenClaimStatus";
export function TokenClaimFlow(t0) {
  const $ = _c(42);
  const {
    tokenReward,
    claimActions
  } = t0;
  const t = useTranslations("wallet.TokenClaimFlow");
  const {
    addCustomToast
  } = useToasts();
  const {
    flow
  } = useSnapshot(FlowState);
  const mode = flow?.mode;
  const transactionIdentifier = flow?.transactionIdentifier;
  let t1;
  if ($[0] !== addCustomToast || $[1] !== mode || $[2] !== tokenReward) {
    t1 = (response, receiptTransactions) => {
      if (response.action === "TRANSACTION") {
        FlowActions.setFlowField("transactionIdentifier", {
          chain: response.transactionIdentifier.chain,
          transactionHash: response.transactionIdentifier.hash
        });
        if (mode === "minimized" && receiptTransactions.length > 0) {
          addCustomToast(() => <TokenClaimToast tokenReward={tokenReward} transactionIdentifier={{
            chain: response.transactionIdentifier.chain,
            transactionHash: response.transactionIdentifier.hash
          }} />, {
            id: "token-claim-toast",
            duration: Number.POSITIVE_INFINITY
          });
          FlowActions.endFlow();
        }
      }
    };
    $[0] = addCustomToast;
    $[1] = mode;
    $[2] = tokenReward;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onAllActionsCompleted = t1;
  if (!tokenReward?.balance) {
    throw new Error("No token reward data available for claiming.");
  }
  if (transactionIdentifier) {
    const t2 = tokenReward.balance?.currency?.imageUrl || null;
    let t3;
    if ($[4] !== t2 || $[5] !== transactionIdentifier) {
      t3 = <TokenClaimStatus tokenImageUrl={t2} transactionIdentifier={transactionIdentifier} />;
      $[4] = t2;
      $[5] = transactionIdentifier;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t2;
  if ($[7] !== t) {
    t2 = t("title");
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <BottomSheetHeaderTitle>{t2}</BottomSheetHeaderTitle>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t) {
    t4 = t("subtitle");
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <TextBody className="mt-1 text-text-secondary" size="sm">{t4}</TextBody>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t3 || $[16] !== t5) {
    t6 = <BottomSheetHeader><Flex className="flex-col">{t3}{t5}</Flex></BottomSheetHeader>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const t7 = `${tokenReward.balance.currency?.chainIdentifier}:${tokenReward.balance.currency?.contractAddress}`;
  const t8 = tokenReward.balance.currency?.imageUrl;
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <ItemAvatar className="bg-bg-additional-1" rounded={true} seed={t7} size={42} src={t8} />;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = tokenReward.balance.currency?.name || "Token";
  let t11;
  if ($[21] !== t10) {
    t11 = <ItemTitle>{t10}</ItemTitle>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = tokenReward.balance.currency?.symbol;
  const t13 = tokenReward.balance.quantity ?? 0;
  let t14;
  if ($[23] !== t12 || $[24] !== t13) {
    t14 = <ItemDescription><NumberDisplay display="standard" suffix={t12} value={t13} /></ItemDescription>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t11 || $[27] !== t14) {
    t15 = <ItemContent>{t11}{t14}</ItemContent>;
    $[26] = t11;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t9) {
    t16 = <FlexColumn className="w-full"><Item className="py-4" variant="unstyled">{t9}{t15}</Item></FlexColumn>;
    $[29] = t15;
    $[30] = t9;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Separator className="hidden h-auto md:block" orientation="vertical" />;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== claimActions || $[34] !== onAllActionsCompleted) {
    t18 = <FlexColumn className="w-full min-w-0 justify-end"><ActionTimeline actions={claimActions} onAllActionsCompleted={onAllActionsCompleted} /></FlexColumn>;
    $[33] = claimActions;
    $[34] = onAllActionsCompleted;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t16 || $[37] !== t18) {
    t19 = <BottomSheetBody><Flex className="size-full min-h-[120px] flex-col gap-6 md:flex-row md:gap-10">{t16}{t17}{t18}</Flex></BottomSheetBody>;
    $[36] = t16;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t19 || $[40] !== t6) {
    t20 = <>{t6}{t19}</>;
    $[39] = t19;
    $[40] = t6;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  return t20;
}